/**
 * User Service
 * Handles user-related API calls
 */
import BaseApiService from '../base/BaseApiService';
import type { User, AssessorWorkload, PaginatedResponse, UserSearchParams } from '@app-types';

class UserService extends BaseApiService {
  /**
   * Get users list, optionally filtered by role
   */
  async getUsers(role?: string): Promise<User[]> {
    const params = role ? `?role=${role}` : '';
    return this.get<User[]>(`/users${params}`);
  }

  /**
   * One page of CO/CM picker candidates: active users matching the search, or exactly the given ids
   */
  async searchUsers({ search, ids, limit, offset }: UserSearchParams): Promise<PaginatedResponse<User>> {
    return this.get<PaginatedResponse<User>>('/users/search', {
      search,
      ids: ids?.join(','),
      limit,
      offset
    });
  }

  /**
   * Get assessors with workload information
   */
  async getAssessorsWithWorkload(): Promise<AssessorWorkload[]> {
    return this.get<AssessorWorkload[]>('/contract-assessment-meetings/assessors-workload');
  }

  /**
   * Get user by ID
   */
  async getUser(id: number): Promise<User> {
    return this.get<User>(`/users/${id}`);
  }
}

export const userService = new UserService();
export default userService;
